import React, { useState } from 'react';
import { PlusIcon, TrashIcon, CalendarIcon, InfoIcon, TruckIcon, CircleDollarSignIcon } from 'lucide-react';
export function ShippingTermsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    currency: initialData.currency || 'USD',
    incoterm: initialData.incoterm || 'FOB',
    paymentTerms: initialData.paymentTerms || '30/70',
    quoteValidUntil: initialData.quoteValidUntil || '',
    desiredDeliveryDate: initialData.desiredDeliveryDate || '',
    notes: initialData.notes || '',
    shipments: initialData.shipments || [{
      origin: 'Spain',
      destination: '',
      method: 'Ocean',
      containerType: '40ft HC',
      totalPrice: 0,
      transitTime: ''
    }],
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    onUpdate({
      ...formData,
      [name]: value
    });
  };
  const handleAddShipment = () => {
    const newShipments = [...formData.shipments, {
      origin: 'Spain',
      destination: '',
      method: 'Ocean',
      containerType: '40ft HC',
      totalPrice: 0,
      transitTime: ''
    }];
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  const handleRemoveShipment = index => {
    const newShipments = formData.shipments.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  const handleShipmentChange = (index, field, value) => {
    const newShipments = [...formData.shipments];
    newShipments[index][field] = value;
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  return <div className="space-y-8" data-id="element-4835">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4836">
        Shipping & Payment Terms
      </div>
      {/* Financial Terms */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4837">
        <div className="flex items-center mb-4" data-id="element-4838">
          <CircleDollarSignIcon size={20} className="text-blue-400 mr-2" data-id="element-4839" />
          <h3 className="text-white font-medium" data-id="element-4840">Financial Terms</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4841">
          <div data-id="element-4842">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4843">Currency</label>
            <select name="currency" value={formData.currency} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-4844">
              <option value="USD" data-id="element-4845">USD ($)</option>
              <option value="EUR" data-id="element-4846">EUR (€)</option>
              <option value="GBP" data-id="element-4847">GBP (£)</option>
              <option value="AUD" data-id="element-4848">AUD (A$)</option>
              <option value="CAD" data-id="element-4849">CAD (C$)</option>
            </select>
          </div>
          <div data-id="element-4850">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4851">Incoterm</label>
            <select name="incoterm" value={formData.incoterm} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-4852">
              <option value="EXW" data-id="element-4853">EXW (Ex Works)</option>
              <option value="FCA" data-id="element-4854">FCA (Free Carrier)</option>
              <option value="FOB" data-id="element-4855">FOB (Free On Board)</option>
              <option value="CFR" data-id="element-4856">CFR (Cost and Freight)</option>
              <option value="CIF" data-id="element-4857">CIF (Cost, Insurance & Freight)</option>
              <option value="DAP" data-id="element-4858">DAP (Delivered At Place)</option>
              <option value="DDP" data-id="element-4859">DDP (Delivered Duty Paid)</option>
            </select>
          </div>
          <div data-id="element-4860">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4861">
              Payment Terms
            </label>
            <select name="paymentTerms" value={formData.paymentTerms} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-4862">
              <option value="100" data-id="element-4863">100% Payment in Advance</option>
              <option value="30/70" data-id="element-4864">30% Advance, 70% Before Shipment</option>
              <option value="50/50" data-id="element-4865">50% Advance, 50% Before Shipment</option>
              <option value="20/80" data-id="element-4866">20% Advance, 80% Before Shipment</option>
              <option value="LC" data-id="element-4867">Letter of Credit</option>
              <option value="NET30" data-id="element-4868">Net 30 Days</option>
            </select>
          </div>
        </div>
      </div>
      {/* Dates */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4869">
        <div className="flex items-center mb-4" data-id="element-4870">
          <CalendarIcon size={20} className="text-blue-400 mr-2" data-id="element-4871" />
          <h3 className="text-white font-medium" data-id="element-4872">Important Dates</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4873">
          <div data-id="element-4874">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4875">
              Quote Valid Until
            </label>
            <div className="relative" data-id="element-4876">
              <input type="date" name="quoteValidUntil" value={formData.quoteValidUntil} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-4877" />
              <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-4878" />
            </div>
          </div>
          <div data-id="element-4879">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-4880">
              Desired Delivery Date
            </label>
            <div className="relative" data-id="element-4881">
              <input type="date" name="desiredDeliveryDate" value={formData.desiredDeliveryDate} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-4882" />
              <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-4883" />
            </div>
          </div>
        </div>
      </div>
      {/* Shipments */}
      <div data-id="element-4884">
        <div className="flex items-center justify-between mb-4" data-id="element-4885">
          <div className="flex items-center" data-id="element-4886">
            <TruckIcon size={20} className="text-blue-400 mr-2" data-id="element-4887" />
            <h3 className="text-white font-medium" data-id="element-4888">Shipment Details</h3>
          </div>
          <button onClick={handleAddShipment} className="text-sm flex items-center text-blue-400 hover:text-blue-300" data-id="element-4889">
            <PlusIcon size={16} className="mr-1" data-id="element-4890" />
            Add Shipment
          </button>
        </div>
        {formData.shipments.map((shipment, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30 mb-4 relative" data-id="element-4891">
            {formData.shipments.length > 1 && <button onClick={() => handleRemoveShipment(index)} className="absolute top-4 right-4 p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4892">
                <TrashIcon size={16} data-id="element-4893" />
              </button>}
            <h4 className="text-white font-medium mb-4" data-id="element-4894">
              Shipment {index + 1}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-4895">
              <div data-id="element-4896">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4897">
                  Origin
                </label>
                <input type="text" value={shipment.origin} onChange={e => handleShipmentChange(index, 'origin', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Country of origin" data-id="element-4898" />
              </div>
              <div data-id="element-4899">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4900">
                  Destination
                </label>
                <input type="text" value={shipment.destination} onChange={e => handleShipmentChange(index, 'destination', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Country of destination" data-id="element-4901" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4902">
              <div data-id="element-4903">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4904">
                  Shipping Method
                </label>
                <select value={shipment.method} onChange={e => handleShipmentChange(index, 'method', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4905">
                  <option value="Ocean" data-id="element-4906">Ocean Freight</option>
                  <option value="Air" data-id="element-4907">Air Freight</option>
                  <option value="Road" data-id="element-4908">Road Transport</option>
                  <option value="Rail" data-id="element-4909">Rail Transport</option>
                  <option value="Multimodal" data-id="element-4910">Multimodal</option>
                </select>
              </div>
              <div data-id="element-4911">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4912">
                  Container Type
                </label>
                <select value={shipment.containerType} onChange={e => handleShipmentChange(index, 'containerType', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-4913">
                  <option value="20ft" data-id="element-4914">20ft Standard</option>
                  <option value="40ft" data-id="element-4915">40ft Standard</option>
                  <option value="40ft HC" data-id="element-4916">40ft High Cube</option>
                  <option value="LCL" data-id="element-4917">LCL (Less than Container Load)</option>
                  <option value="Bulk" data-id="element-4918">Bulk Cargo</option>
                  <option value="Pallet" data-id="element-4919">Palletized</option>
                </select>
              </div>
              <div data-id="element-4920">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-4921">
                  Shipping Price
                </label>
                <div className="relative" data-id="element-4922">
                  <span className="absolute left-4 top-2.5 text-gray-400" data-id="element-4923">
                    {formData.currency === 'USD' ? '$' : formData.currency === 'EUR' ? '€' : formData.currency === 'GBP' ? '£' : formData.currency === 'AUD' ? 'A$' : 'C$'}
                  </span>
                  <input type="number" value={shipment.totalPrice} onChange={e => handleShipmentChange(index, 'totalPrice', parseFloat(e.target.value))} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-8 pr-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-4924" />
                </div>
              </div>
            </div>
            <div className="mt-4" data-id="element-4925">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-4926">
                Estimated Transit Time
              </label>
              <input type="text" value={shipment.transitTime} onChange={e => handleShipmentChange(index, 'transitTime', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="E.g. 4-6 weeks" data-id="element-4927" />
            </div>
          </div>)}
      </div>
      {/* Additional Notes */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4928">
        <div className="flex items-center mb-4" data-id="element-4929">
          <InfoIcon size={20} className="text-blue-400 mr-2" data-id="element-4930" />
          <h3 className="text-white font-medium" data-id="element-4931">Additional Notes</h3>
        </div>
        <div data-id="element-4932">
          <textarea name="notes" value={formData.notes} onChange={handleChange} rows={4} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter any additional notes, special requirements or terms..." data-id="element-4933"></textarea>
        </div>
      </div>
    </div>;
}